<template>
  <div>
    <div class="litops orangeToYellow" :style="{
      height: '60px',
      textAlign: 'center',
      color: '#ffffff',
      lineHeight: '60px',
      fontSize: '20px',
      fontWeight: 500
    }">
      添加设备
    </div>
    <div class="rform">
      <van-form @submit="handleSubmit">
        <!-- 网关类型 -->
        <van-field name="radio" :label="$t('bind.type')" v-if="showTabs">
          <template #input>
            <van-radio-group v-model="radio" direction="horizontal" @change="handleRadio">
              <van-radio name="1">网关</van-radio>
              <van-radio name="2">RTU</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <div v-if="radio === '1'">
          <!-- 网关id -->
          <div class="scan">
            <van-field name="wgID" v-model="wgID" label="设备ID" placeholder="设备ID">
              <template #button>
                <van-button class="scan_code" @click.stop="handleSacnCode">
                  <img width="20" height="20" src="./../../../assets/images/scancode.png" />
                </van-button>
              </template>
            </van-field>
          </div>
          <!-- 网关密码 -->
          <van-field name="pwd" v-model="pwd" :type="isTxt ? 'text' : 'password'" label="设备密码" placeholder="设备密码">
            <template #button>
              <van-button class="scan_code" @click.stop.prevent="handleViewPwd">
                <van-icon v-if="!isTxt" name="eye-o" size="20" />
                <van-icon v-else name="closed-eye" size="20" />
              </van-button>
            </template>
          </van-field>
        </div>
        <div v-else>
          <!-- RTU id -->
          <div class="scan">
            <van-field v-model="rtuID" @input="e => rtuInputDebunce(e)" aria-autocomplete="off" autocomplete="off"
              maxlength="8" name="rtuID" label="RTU ID" placeholder="RTU ID">
              <template #button>
                <van-button class="scan_code" @click.stop="handleSacnCode">
                  <img width="20" height="20" src="./../../../assets/images/scancode.png" />
                </van-button>
              </template>
            </van-field>
          </div>
          <!-- RTU密码 -->
          <van-field name="pwd" v-model="pwd" :type="isTxt ? 'text' : 'password'" label="RTU密码" placeholder="RTU密码">
            <template #button>
              <van-button class="scan_code" @click.stop.prevent="handleViewPwd">
                <van-icon v-if="!isTxt" name="eye-o" size="20" />
                <van-icon v-else name="closed-eye" size="20" />
              </van-button>
            </template>
          </van-field>
          <!-- 网关 id -->
          <van-field name="wgID" v-model="wgID" label="所属网关" placeholder="网关ID" disabled />
          <!-- 端口1 -->
          <!-- <van-field name="port1" v-model="port1" :disabled="true" label="端口1" :placeholder="valaveDisable ? '没有查询到相关阀门数据':'请选择要绑定的阀门'" @click="onFocus(1)" /> -->

          <div class="van-cell">
            <div class="van-cell__title van-field__label">端口1</div>
            <div class="van-cell__value van-field__value van-field__control" @click="onFocus(1)">
              {{
                port1
                  ? port1
                  : valaveDisable
                    ? "没有查询到相关阀门数据"
                    : "请选择要绑定的阀门"
              }}
            </div>
          </div>

          <div class="port-tip">
            <van-icon name="warning" :style="{ color: '#3566DC', marginRight: '4px' }" /><span
              class="blue">端口1：阀控</span>
            <span class="red">红线</span>
            <span class="blue">
              <van-icon name="down" :style="{ color: '#3566DC', transform: 'rotate(270deg)' }" />
            </span>
            <span class="blue">电磁头</span>
            <span class="red">红线</span>
            <span class="blue">，</span>
            <span class="blue">阀控</span>
            <span class="black">黑线</span>
            <span class="blue">
              <van-icon name="down" :style="{ color: '#3566DC', transform: 'rotate(270deg)' }" />
            </span>
            <span class="blue">电磁头</span>
            <span class="black">黑线</span>
          </div>
          <!-- 端口2 -->
          <!-- <van-field name="port2" v-model="port2" :disabled="true" label="端口2" :placeholder="valaveDisable ? '没有查询到相关阀门数据':'请选择要绑定的阀门'" @click="onFocus(2)" /> -->

          <div class="van-cell">
            <div class="van-cell__title van-field__label">端口2</div>
            <div class="van-cell__value van-field__value van-field__control" @click="onFocus(2)">
              {{
                port2
                  ? port2
                  : valaveDisable
                    ? "没有查询到相关阀门数据"
                    : "请选择要绑定的阀门"
              }}
            </div>
          </div>

          <div class="port-tip">
            <van-icon name="warning" :style="{ color: '#3566DC', marginRight: '4px' }" /><span
              class="blue">端口2：阀控</span>
            <span class="yellow">黄线</span>
            <span class="blue">
              <van-icon name="down" :style="{ color: '#3566DC', transform: 'rotate(270deg)' }" />
            </span>
            <span class="blue">电磁头</span>
            <span class="red">红线</span>
            <span class="blue">，</span>
            <span class="blue">阀控</span>
            <span class="green">绿线</span>
            <span class="blue">
              <van-icon name="down" :style="{ color: '#3566DC', transform: 'rotate(270deg)' }" />
            </span>
            <span class="blue">电磁头</span>
            <span class="black">黑线</span>
          </div>
        </div>
        <!-- 提交 -->
        <div class="btns">
          <!-- <van-button class="submit" round block type="info" native-type="submit">
            添加{{ radio === '1' ? '设备' : 'RTU' }}
          </van-button> -->

          <van-button class="btn cancelBtn" @click="handleCancel">取消</van-button>
          <van-button class="btn confirmBtn" native-type="submit">确定</van-button>
          <van-button class="btn confirmBtn" @click.native.prevent="handleUnBind">解绑设备</van-button>
        </div>
      </van-form>

      <van-popup class="popup123" v-model="ishow" position="bottom" @click-overlay="() => (ishow = false)">
        <van-picker :title="popTit" confirm-button-text="确定" cancel-button-text="取消" show-toolbar
          :columns="pickerIndex === 1 ? valaveList : valaveList2" :default-index="defaultIndex" @confirm="onPopConfirm"
          @cancel="onPopCancel" />
      </van-popup>
    </div>
  </div>
</template>
<script>
import config from '@/utils/config'
import { Dialog } from 'vant'

export default {
  data () {
    let valveRtuRelationList = sessionStorage.getItem('valveRtuRelationList')
    if (valveRtuRelationList) {
      valveRtuRelationList = JSON.parse(valveRtuRelationList)
    } else {
      valveRtuRelationList = []
    }
    const deviceType = sessionStorage.getItem('deviceType')
    return {
      radio: '1',
      rtuID: '',
      wgID: '',
      pwd: '',
      isTxt: false,
      showTabs: false,
      ishow: false,
      port1: '',
      port2: '',
      defaultIndex: 0,
      popTit: '端口1',
      pickerIndex: 1,
      valaveList: [],
      valaveList2: [],
      valaveDisable: true,
      valaveIds: [],
      href: '',
      valveRtuRelationList,
      deviceType
    }
  },

  created () {
    const query = this.$route.query
    if (query.wgId) {
      // this.rtuID = query.rtuId
      this.wgID = query.wgId
      this.radio = '2'
    }
    this.rtuInputDebunce = this.$debounce(this.getPortAndValae, 500)

    this.href = window.location.href

    this.refreshValveCol()
  },

  methods: {
    getPortAndValae (val) {
      if (val && String(val.trim()).length > 7) {
        this.port1 = ''
        this.port2 = ''
        this.valaveIds = []
        //  getPortAndValae
        this.$api
          .getRtuPort({
            rtuNo: String(val.trim())
          })
          .then(res => {
            const { data } = res
            if (data && data.length) {
              this.valaveDisable = false
              this.valaveIds = [...data]

              // 查询到RTU的端口信息  需要匹配id 对应的 irrindex
              console.log('111111:', this.valaveList)
              console.log('222222:', this.valaveList2)

              if (
                data &&
                data.length &&
                this.valveRtuRelationList &&
                this.valveRtuRelationList.length
              ) {
                data.map((o, i) => {
                  const tar = this.valveRtuRelationList.find(
                    t => t.valveId === o.id
                  )
                  console.log('tar:', tar ? tar.irriIndex : 'no')

                  if (tar) {
                    this[`port${o.port}`] = this[
                      `${i === 0 ? 'valaveList' : 'valaveList2'}`
                    ][tar.irriIndex]
                  }
                })
              }
            }
          })
      }
    },

    handleRadio (e) {
      this.radio = e
      this.resetState()
    },

    wxConfig () {
      const that = this
      this.$api
        .getWxConfig({
          appid: config.getAppId(),
          url: window.location.href
        })
        .then(async res => {
          if (res.errcode === 0) {
            const {
              sign: { timestamp, noncestr, signature }
            } = res

            window.wx.config({
              timestamp: Number(timestamp),
              nonceStr: noncestr,
              signature,
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: config.getAppId(), // 必填，公众号的唯一标识
              jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表
            })

            window.wx.ready(function () {
              // alert("readyready")
              window.wx.checkJsApi({
                jsApiList: ['scanQRCode'],
                success: function (res) {
                  // alert("ready22:", typeof res === "string" ? res : JSON.stringify(res))
                  if (res.checkResult.scanQRCode) {
                    that.scan()
                  }
                }
              })
            })
          } else {
            this.$toast({
              type: 'fail',
              message: res.errmsg || this.$t('bind.msg_error_wg')
            })
          }
        })
    },

    // 扫码
    async handleSacnCode (e) {
      e.preventDefault()
      e.stopPropagation()
      //   获取wx的相关api配置
      await this.wxConfig()
    },

    scan () {
      const that = this
      this.$wx.scanQRCode({
        needResult: 1, // 当needResult 为 1 时，扫码返回的结果
        scanType: ['qrCode', 'barCode'],
        success: function (res) {
          setTimeout(() => {
            const result = res.resultStr
            const info = result.split('|')
            if (that.radio === '1') {
              that.wgID = info[0]
            } else {
              that.rtuID = info[0]
              that.getPortAndValae(info[0])
            }

            that.pwd = info[1]
          }, 200)
        },
        fail: function (res) {
          console.error('res:', res)
          that.$toast(
            '扫码失败:',
            typeof res === 'string' ? res : JSON.stringify(res)
          )
        }
      })
    },

    // 密码可见
    handleViewPwd () {
      this.isTxt = !this.isTxt
    },

    onFocus (type) {
      console.log('123123:', type, this.valaveDisable)

      this.popTit = `端口${type}`
      this.pickerIndex = type
      this.ishow = !this.valaveDisable
    },

    onPopConfirm (name, index) {
      console.log('name, index: ', name, index)
      // 判断阀门是否已经使用
      // 在已有的阀门上进行判断
      // 在选择了的阀门上进行判断
      const tar1 = this.valveRtuRelationList.find(o => o.irriIndex === index)
      const tar2 = this.valaveIds.find(o => o.index === index)

      if (tar1 || tar2) {
        return this.$toast(`该阀门${tar1 ? '已绑定' : tar2 ? '已占用' : ''}`)
      }

      this[`port${this.pickerIndex}`] = name
      this.valaveIds[this.pickerIndex - 1].index = index
      this.onPopCancel()

      this.refreshValveCol()
    },

    onPopCancel () {
      this.ishow = false
    },

    // 更新阀门列
    refreshValveCol () {
      const num =
        this.deviceType == 13 || this.deviceType == 17
          ? 128
          : this.deviceType == 18 || this.deviceType == 24
            ? 160
            : 32

      const list = new Array(num).fill()
      const arr = ['', 2]

      arr.map(n => {
        this[`valaveList${n}`] = list
          .map((o, i) => {
            const tar1 = this.valveRtuRelationList.find(o => o.irriIndex === i)
            const tar2 = this.valaveIds.find(o => o.index === i)

            if (!tar1 && !tar2) {
              return `阀门${i + 1}`
            } else {
              return `阀门${i + 1}-${tar1 ? '已绑定' : tar2 ? '已占用' : ''}`
            }
          })
          .filter(o => o)
      })
    },

    // 重置
    resetState () {
      Object.assign(this.$data, this.$options.data())
    },

    showTip (type, msg) {
      this.$toast.clear(true)
      this.$toast({
        type,
        message: msg
      })
    },

    handleCancel () {
      this.$router.back()
    },

    // 解绑RTU设备
    async handleUnBind () {
      if (!this.wgID) return this.$toast('网关编号不能为空')
      // if (!this.rtuID) return this.$toast('RTU编号不能为空')

      Dialog({
        title: '解绑设备',
        message: `确认要解绑「${this.wgID}」设备吗？`,
        showCancelButton: true
      })
        .then(async () => {
          this.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
          })
          await this.$api.deleteGateway({
            no: this.wgID.trim() // 网关编号
          })
            .then(res => {
              const { errcode } = res
              if (errcode === 0) {
                this.$toast('解绑成功')
              } else {
                this.$toast(`解绑RTU失败:${res.errmsg}`)
              }
            })
        })
        .catch(() => {
          // on cancel
        })
    },

    // 激活
    async handleSubmit () {
      // 校验不能为空
      const { pwd, rtuID, wgID, radio } = this
      //   网关
      if (radio === '1') {
        if (!wgID.trim()) return this.$toast(this.$t('bind.msg_wgID'))
        if (!pwd.trim()) return this.$toast(this.$t('bind.msg_wgPWD'))
        //   绑定网关
        try {
          await this.$api
            .bingGateWay({
              no: wgID.trim(),
              code: pwd.trim()
            })
            .then(res => {
              console.log('res:', res)

              if (res.errcode === 0) {
                this.$toast({
                  type: 'success',
                  message: this.$t('bind.msg_success_wg')
                })
                this.resetState()
              } else {
                this.$toast({
                  type: 'fail',
                  message: res.errmsg || this.$t('bind.msg_error_wg')
                })
              }
            })
            .catch(err => {
              this.$toast({
                type: 'error',
                message: err.errmsg || this.$t('bind.msg_error_wg')
              })
            })
        } catch (error) {
          console.error(error)
        }
      } else {
        // RTU
        if (!rtuID.trim()) return this.$toast(this.$t('bind.msg_rtuID'))
        if (!pwd.trim()) return this.$toast(this.$t('bind.msg_rtuPWD'))
        if (!wgID.trim()) return this.$toast(this.$t('bind.msg_wgID'))

        // 绑定RTU
        this.$toast({
          type: 'loading',
          message: '加载中...',
          duration: 0
        })

        const valveList = []
        this.valaveIds.map(item => {
          if (item.hasOwnProperty('index')) {
            valveList.push({
              index: item.index,
              valveId: item.id
            })
          }
        })

        await this.$api
          .bindRtuValve({
            gatewayNo: wgID.trim(),
            rtuNo: rtuID.trim(),
            secret: pwd.trim(),
            valveList
          })
          .then(async res => {
            this.$toast.clear()
            if (res.errcode !== 0) {
              return this.showTip('fail', res.errmsg || '绑定失败')
            }

            this.showTip('success', '绑定成功')

            setTimeout(() => {
              this.$router.go(-2)
            }, 2000)

            // this.resetState()

            // 再将RTU绑定到网关下
            // await this.$api
            //   .bingRTUInGateWay({
            //     no: rtuID,
            //     gatewayNo: wgID,
            //   })
            //   .then((_res) => {
            //     if (_res.errcode === 0) {
            //       this.showTip('success', this.$t('bind.msg_success_wg_rtu'))
            //       this.resetState()
            //     } else {
            //       this.showTip(
            //         'fail',
            //         res.errmsg || this.$t('bind.msg_error_wg_rtu'),
            //       )
            //     }
            //   })
            //   .catch((err) => {
            //     this.showTip(
            //       'fail',
            //       err.errmsg || this.$t('bind.msg_error_wg_rtu'),
            //     )
            //   })
          })
          .catch(err => {
            this.showTip('fail', err.errmsg || this.$t('bind.msg_error_rtu'))
            this.$toast.clear()
          })
      }
    }
  }
}
</script>

<style>
body {
  width: 100%;
  height: 100%;
  /* background: url(../../../assets/images/lobg.jpg) top no-repeat; */
  background-size: 100% 100%;
}
</style>

<style lang="scss" scoped>
::v-deep .van-field__control:disabled {
  -webkit-text-fill-color: #323233 !important;
}

::v-deep .van-field--disabled .van-field__label {
  color: #646566 !important;
}

.rform {
  width: 6rem;
  margin: 0 auto;
  padding: 0 0.2rem;
  padding-top: 0.77rem;
  margin-top: 20px;

  ::v-deep .van-cell {
    padding: 0;
    // box-shadow: 0 0.05rem 0.1rem #827d88;
    border: 0.4px solid #bdbdbd;
    border-radius: 6.18182px;
    margin-bottom: 0.2rem;

    .van-field__control {
      padding: 16px 0;
    }

    .van-field__label {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .van-button--default {
    border: none !important;
  }

  .scan {
    display: flex;

    .scan_code {
      align-items: center;
      justify-content: center;

      img {
        width: 0.4rem;
        height: 0.4rem;
      }
    }
  }
}

// 注册
.submit {
  width: 6rem;
  height: 48px;
  line-height: 48px;
  background: #27b0f6;
  text-align: center;
  color: #fff;
  margin: 0rem auto 0;
  font-size: 16px;
  box-shadow: 0 0.05rem 0.1rem #827d88;
  border-radius: 0;
  border: 0 !important;
}

.btns {
  display: flex;
  justify-content: space-evenly;
  margin-top: 40px;

  .btn {
    width: 108.8px;
    height: 49.87px;
    color: #ffffff;
  }

  .cancelBtn {
    background: #dadada;
    box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.1);
    border-radius: 6.18182px;
  }

  .confirmBtn {
    background: #3566dc;
    box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.1);
    border-radius: 6.18182px;
    margin: 0 8px;
  }
}

.port-tip {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;

  .yellow {
    color: #e2750f;
  }

  .blue {
    display: flex;
    align-items: center;
    color: #3566dc;
  }

  .red {
    color: #f22d13;
  }

  .green {
    color: rgb(19, 213, 19);
  }

  .black {
    color: #000000;
  }
}
</style>
